module.exports = __webpack_public_path__ + "static/media/CN-25.47fb67fb.png";